export const SHOW_SNACKBAR_REQUEST = 'SHOW_SNACKBAR_REQUEST'
export const HIDE_SNACKBAR_REQUEST = 'HIDE_SNACKBAR_REQUEST'
export const ADD_PENDING_MESSAGE = 'ADD_PENDING_MESSAGE'
export const REMOVE_FIRST_PENDING_MESSAGE = 'REMOVE_FIRST_PENDING_MESSAGE'
